import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling, Routes } from '@angular/router';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { BlockUIModule } from 'ng-block-ui';
import { JwtModule } from '@auth0/angular-jwt';

import { CORE_CUSTOM_CONFIG } from '@core/services/config';
import { coreConfig } from 'app/app-config';
import { CustomBreakPointsProvider } from 'app/layout/custom-breakpoints';
import { MAIN_ROUTES } from './main/main.routes';
import { ApiInterceptor } from './common/interceptor/api-interceptor';
import { AuthService } from './common/services/auth';
import { CountriesService } from './common/services/countries';






const appRoutes: Routes = [
  ...MAIN_ROUTES,
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/pages/miscellaneous/error' } // Error 404 - Page not found
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    importProvidersFrom(
      FlexLayoutModule.withConfig({ disableDefaultBps: true }),
      TranslateModule.forRoot(),
      ToastrModule.forRoot(),
      SweetAlert2Module.forRoot(),
      BlockUIModule.forRoot({ message: 'Loading...' }),
      JwtModule.forRoot({ config: { allowedDomains: ['localhost:4201'] } })
    ),
    importProvidersFrom(BlockUIModule.forRoot()),
    CustomBreakPointsProvider,
    { provide: CORE_CUSTOM_CONFIG, useValue: coreConfig },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    AuthService,
    CountriesService
  ]
};
